import React, { useState } from "react";
import Button from '@mui/material/Button';
import { downloadClientsBySellerEvent, downloadPricesBySellerEvent } from '../../../_events/clients/find_clients.event';
import { message } from "antd";
import { downloadExcelFile } from "../../../_utils/download_file.util";
import DownloadModal from "./download_modal";

const DownloadSellerPrices = () => {

    const [open, setOpen] = useState(false);
    const [openC, setOpenC] = useState(false);
    const [downloading, setDownloading] = useState(false);


    const openModal = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const openModalC = () => {
        setOpenC(true);
    };

    const handleCloseC = () => {
        setOpenC(false);
    };

    const downloadPrices = () => {
        setDownloading(true);
        let id = document.getElementById('client_seller').value;
        if(id == null || id === ''){
            throw new Error('No hay vendedor seleccionado');
        }
        downloadPricesBySellerEvent(id)
        .then(data => {
            setDownloading(false);
            downloadExcelFile(data.data.bytes, 'precios_cliente');
        })
        .catch(err => {
            message.error(err.message);
            setDownloading(false);
        });
    }

    const downloadClients = () => {
        setDownloading(true);
        let id = document.getElementById('client_seller').value;
        if(id == null || id === ''){
            throw new Error('No hay vendedor seleccionado');
        }
        downloadClientsBySellerEvent(id)
        .then(data => {
            setDownloading(false);
            downloadExcelFile(data.data.bytes, 'clientes_vendedor');
        })
        .catch(err => {
            message.error(err.message);
            setDownloading(false);
        });
    }

    return(
        <>
            <Button
                  variant="contained" 
                  size="small"
                  onClick={() => openModal()}     
            >
                Precios x Vendedor
            </Button>
            <DownloadModal 
                open={open}
                handleClose={handleClose}
                downloading={downloading}
                download={downloadPrices}
            />
            <Button
                style={{ marginLeft: '10px' }}
                variant="contained" 
                size="small"
                onClick={() => openModalC()}     
            >
                Clientes x Vendedor
            </Button>
            <DownloadModal 
                open={openC}
                handleClose={handleCloseC}
                downloading={downloading}
                download={downloadClients}
            />
        </>
    );
}

export default DownloadSellerPrices;